import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import styles from "../Styles/registerContainer.module.css";
import { lang } from "../Utils/lang";
import { Controller, useForm } from "react-hook-form";
import { LoginModel } from "../Models/LoginModel";
import { yupResolver } from "@hookform/resolvers/yup";
import { postData } from "../Services/postData";
import { localUrlEnum, urlEnum } from "../Utils/urlEnum";
import { useNavigate } from "react-router";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";

// interface LoginData {
//     email: string;
//     password: string;
// };

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const { handleSubmit, control } = useForm({
    resolver: yupResolver(LoginModel),
  });

  // Function to toggle password visibility
  const handleClickShowPassword = () => setShowPassword((prev: boolean) => !prev);

  // Function to prevent mouse down default behavior
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault();

  async function handleUserDataSubmit(payload: any) {
    // eslint-disable-next-line no-console
    const response = await postData(urlEnum.login, payload);
    if (response && response.data) {
      localStorage.setItem("useId", response.data.userId);
      localStorage.setItem("userName", response.data.email);
      localStorage.setItem("userEmail", response.data.email);
      localStorage.setItem("access_token", response.data.jwt);
      localStorage.setItem("roles", JSON.stringify(response.data.roles));

      navigate(localUrlEnum.companies);
      window.location.reload();
    }
  }

  return (
    <div className={styles.registerContainer}>
      <div className={styles.imageContainer}>
        <img src="/ccf2.png" alt="Register Img" />
      </div>
      <div className={styles.formContainer}>
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          alignItems="center"
          sx={{ minHeight: "100vh" }}
        >
          <Grid
            item
            sx={{
              flex: 2,
              mt: 8,
              mb: 0,
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <h1>{lang.login}</h1>
          </Grid>
          <Grid item sx={{ flex: 4, mt: 8, mb: 2, width: "70%" }}>
            <form
              onSubmit={handleSubmit(handleUserDataSubmit)}
              method="get"
              id="checkUserData"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Controller
                name="email"
                defaultValue=""
                control={control}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <TextField
                    onChange={onChange}
                    fullWidth
                    style={{
                      marginBottom: 15,
                    }}
                    value={value}
                    error={!!error}
                    helperText={error?.message}
                    id="email"
                    label={lang.email}
                    size="small"
                    variant="outlined"
                  />
                )}
              />
              <Controller
                name="password"
                defaultValue=""
                control={control}
                render={({
                  field: { value, onChange },
                  fieldState: { error },
                }) => (
                  <TextField
                    onChange={onChange}
                    fullWidth
                    style={{
                      marginBottom: 15,
                    }}
                    value={value}
                    error={!!error}
                    helperText={error?.message}
                    id="password"
                    label={lang.password}
                    size="small"
                    variant="outlined"
                    type={showPassword ? "text" : "password"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
              <Button variant="contained" type="submit">
                {lang.login}
              </Button>
            </form>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
